/**
 *
 * DropdownActions
 *
 */

import React from 'react';
import { PropTypes } from 'prop-types';
import { Dropdown } from 'antd';
import DropdownMenu from 'components/DropdownMenu/Loadable';
import { QA_SUBMENU_BUILT_IN_PLACEMENTS } from 'components/DropdownMenu/placements';
import {
  actionShape,
  groupedActionShape,
} from 'components/DropdownActions/prop-shape';
import { insertActionDividers } from 'components/DropdownMenu/utils';

function DropdownActions(props) {
  const {
    dropdownIcon = <span />,
    dropdownTrigger = ['click'],
    dropdownClassName = null,
    menuPlacement = 'bottomRight',
    menuStyle = {},
    menuClassName = null,
    menuTitle = null,
    menuCloseOnAction = true,
    onChangeStatus = () => {},
    actions = [],
    groupedActions = [],
    item = {},
    style = {},
    header = null,
    disabled = false,
    visible,
    children,
    getPopupContainer,
    destroyPopupOnHide = true,
    overlayStyle = {},
    align,
    menuMode,
    menuGetPopupContainer,
    menuDataTestId,
  } = props;
  const rightAligned =
    menuPlacement === 'bottomRight' || menuPlacement === 'topRight';
  const isVisibilityControlled = typeof visible === 'boolean';
  const ActionMenu = (
    <DropdownMenu
      style={menuStyle}
      className={menuClassName}
      title={menuTitle}
      item={item}
      actions={insertActionDividers(actions)}
      groupedActions={groupedActions}
      closeOnAction={menuCloseOnAction}
      header={header}
      mode={menuMode}
      getPopupContainer={menuGetPopupContainer || getPopupContainer}
      builtinPlacements={
        menuMode === 'vertical-right'
          ? QA_SUBMENU_BUILT_IN_PLACEMENTS
          : undefined
      }
      subMenuOpenDelay={menuMode === 'vertical-right' ? 0 : undefined}
      data-testid={menuDataTestId}
    />
  );

  return (
    <Dropdown
      className={dropdownClassName}
      placement={menuPlacement}
      overlay={ActionMenu}
      trigger={dropdownTrigger}
      arrowPointAtCenter
      getPopupContainer={getPopupContainer || ((trigger) => trigger.parentNode)}
      align={align ?? (rightAligned ? { useCssRight: true } : undefined)}
      destroyPopupOnHide={destroyPopupOnHide}
      overlayStyle={{ maxWidth: 300, ...overlayStyle }}
      {...(isVisibilityControlled ? { visible } : {})}
      onVisibleChange={onChangeStatus}
      disabled={disabled}
    >
      <div
        className="display-inline-block vertical-align-middle"
        style={style}
        data-testid="dropdown-actions"
      >
        {children}
        {dropdownIcon}
      </div>
    </Dropdown>
  );
}

DropdownActions.propTypes = {
  dropdownIcon: PropTypes.element,
  dropdownTrigger: PropTypes.arrayOf(PropTypes.string),
  dropdownClassName: PropTypes.string,
  menuPlacement: PropTypes.oneOf([
    'bottomLeft',
    'bottomCenter',
    'bottomRight',
    'topLeft',
    'topCenter',
    'topRight',
  ]),
  menuStyle: PropTypes.object,
  menuClassName: PropTypes.string,
  menuTitle: PropTypes.any,
  menuCloseOnAction: PropTypes.bool,
  onChangeStatus: PropTypes.func,
  actions: actionShape,
  groupedActions: groupedActionShape,
  item: PropTypes.any,
  children: PropTypes.any,
  style: PropTypes.object,
  header: PropTypes.object,
  disabled: PropTypes.bool,
  visible: PropTypes.bool,
  getPopupContainer: PropTypes.func,
  destroyPopupOnHide: PropTypes.bool,
  overlayStyle: PropTypes.object,
  align: PropTypes.object,
  menuMode: PropTypes.oneOf([
    'vertical',
    'vertical-left',
    'vertical-right',
    'horizontal',
    'inline',
  ]),
  menuGetPopupContainer: PropTypes.func,
  menuDataTestId: PropTypes.string,
};

export default DropdownActions;
